import {CREATE_SELLER, GET_SELLERS, UPDATE_SELLER_STATUS} from './constants';

export function getSellersAction(payload: object) {
  return {
    type: GET_SELLERS,
    payload,
  };
}


export function updateSellerStatus(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: UPDATE_SELLER_STATUS,
    payload,
  };
}

export function createSellerAction(payload: object) {
  return {
    type: CREATE_SELLER,
    payload,
  };
}
